import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { TransportManagementProfileModel } from '../models';
import { TransportManagementProfileEndpoint } from '../constants/transport-management-profile-endpoint';

@Injectable({
  providedIn: 'root',
})
export class TransportManagementProfileItemService {
  constructor(private http: WrapperHttpService) {}

  getTransportManagementProfile(id: number): Observable<TransportManagementProfileModel> {
    const url = `${API_URL}${TransportManagementProfileEndpoint.Base}${TransportManagementProfileEndpoint.Profiles}/${id}`;
    return this.http.withLoading().get<TransportManagementProfileModel>(url);
  }

  createTransportManagementProfile(
    body: Partial<TransportManagementProfileModel>,
  ): Observable<TransportManagementProfileModel> {
    const url = `${API_URL}${TransportManagementProfileEndpoint.Base}${TransportManagementProfileEndpoint.Profiles}`;
    return this.http.withLoading().post<TransportManagementProfileModel>(url, body);
  }

  updateTransportManagementProfile(
    body: Partial<TransportManagementProfileModel>,
  ): Observable<TransportManagementProfileModel> {
    const url = `${API_URL}${TransportManagementProfileEndpoint.Base}${TransportManagementProfileEndpoint.Profiles}`;
    return this.http.withLoading().post<TransportManagementProfileModel>(url, body);
  }
}
